import { useState, useEffect } from "react";
import { SimpleFormSelectOption } from "src/app/components/form/SimpleFormSelect";
import { UserRole, UserTransport } from "src/app/transports/user";
import { useAuth } from "src/app/utils/useAuth";

const useUserByRoleOptions = (inicialRequest: boolean = true) => {
    const [adminsOptions, setAdminsOptions] = useState<SimpleFormSelectOption[]>([]);
    const [managersOptions, setManagersOptions] = useState<SimpleFormSelectOption[]>([]);
    const [linkersOptions, setLinkersOptions] = useState<SimpleFormSelectOption[]>([]);
    const { currentUser } = useAuth();
    const [error, setError] = useState<any>();
    const [loading, setLoading] = useState(true);

    const fetch = async () => {
        const roles: string[] = [
            UserRole.ROLE_SUPER_ADMIN,
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_LEAD_LINKER,
            UserRole.ROLE_LINKER,
        ].map((v) => v.toString());
        setLoading(true);
        const usersByMetaRole: {
            admins: SimpleFormSelectOption[];
            managers: SimpleFormSelectOption[];
            linkers: SimpleFormSelectOption[];
        } = await UserTransport.listByRoles({ roles })
            .then((res) => {
                return res.reduce(
                    (acc: any, user) => {
                        if (
                            [UserRole.ROLE_SUPER_ADMIN, UserRole.ROLE_ADMIN]
                                .map((v) => v.toString())
                                .includes(user.role)
                        ) {
                            acc.admins.push({
                                label: `${user.firstName} ${user.lastName}`,
                                value: user.id,
                            });
                        }

                        if (
                            [UserRole.ROLE_LEAD_PROJECT_MANAGER, UserRole.ROLE_PROJECT_MANAGER]
                                .map((v) => v.toString())
                                .includes(user.role)
                        ) {
                            if (
                                currentUser.role === UserRole.ROLE_ADMIN ||
                                currentUser.id === user.id ||
                                currentUser.id === user.lead?.id
                            ) {
                                acc.managers.push({
                                    label: `${user.firstName} ${user.lastName}`,
                                    value: user.id,
                                });
                            }
                        }

                        if (
                            [UserRole.ROLE_LEAD_LINKER, UserRole.ROLE_LINKER]
                                .map((v) => v.toString())
                                .includes(user.role)
                        ) {
                            acc.linkers.push({
                                label: `${user.firstName} ${user.lastName}`,
                                value: user.id,
                            });
                        }

                        return acc;
                    },
                    { admins: [], linkers: [], managers: [] }
                );
            })
            .catch((e: any) => setError(e))
            .finally(() => setLoading(false));

        setAdminsOptions(usersByMetaRole.admins);
        setManagersOptions(usersByMetaRole.managers);
        setLinkersOptions(usersByMetaRole.linkers);
    };

    const refresh = () => {
        if (!loading) fetch();
    };

    useEffect(() => {
        if (inicialRequest) {
            fetch();
        } else {
            setLoading(false);
        }
    }, []);

    return { adminsOptions, managersOptions, linkersOptions, loading, error, refresh };
};

export default useUserByRoleOptions;
